export { Star052 } from "./Star052";
